<overlay-scrollbars [options]="scrollOptions" class="moduleAlphabetizedList" *ngIf="!grouped">
    <ul class="list-unstyled overflow-hidden" [hidden]="navigationService.modulesLoading"
        (mouseenter)="openPreview.emit()"
        (mouseleave)="closePreview.emit()">
        <li class="sidebarModule" *ngFor="let module of modules | filterText: filterText : 'LocalizedName'"
            [attr.draggable]="!navigationService.addingModule && !navigationService.showOverlay"
            (click)="onModuleClicked(module)"
            (dragstart)="onDragStart($event, module)"
            (dragend)="onDragEnd($event, module)"
            (mouseenter)="previewModuleChange.emit(module)"
            (mouseleave)="previewModuleChange.emit(null)">
            <a class="nav-sidebar-link sidebarMenuItem" [attr.id]="'module-' + module.ModuleID">
                <span class="navMenuGroupText">{{ module.LocalizedName }}</span>
            </a>
        </li>
    </ul>
</overlay-scrollbars>

<overlay-scrollbars [options]="scrollOptions" class="moduleGroupedList" *ngIf="grouped">
    <ul class="list-unstyled overflow-hidden" [hidden]="navigationService.modulesLoading" (mouseleave)="closePreview.emit()">
        <li *ngFor="let moduleGroup of filteredGroups">
            <a [attr.id]="'moduleGroup-' + moduleGroup.localizedGroup" (click)="onModuleGroupClicked(moduleGroup)"
                class="moduleGroup nav-sidebar-link sidebarMenuItem dropdown-toggle"
                [class.expanded]="expandedGroups.has(moduleGroup.localizedGroup) || filterText.length > 0">
                <div class="moduleGroupIcon">
                    <svg class="icon-16 fill-casper" *ngIf="moduleGroup.icon"><use [attr.href]="getModuleGroupSvgPath(moduleGroup.icon)"></use></svg>
                </div>
                <span class="navMenuGroupText">{{ moduleGroup.localizedGroup }}</span>
            </a>

            <ul class="list-unstyled sub-menu-links" [ngbCollapse]="!expandedGroups.has(moduleGroup.localizedGroup) && filterText.length === 0"
                (mouseenter)="openPreview.emit()"
                (mouseleave)="previewModuleChange.emit(null)">
                <li class="sidebarModule" *ngFor="let module of moduleGroup.modules | filterText: filterText : 'LocalizedName'"
                    [attr.draggable]="!navigationService.addingModule && !navigationService.showOverlay"
                    (click)="onModuleClicked(module)"
                    (dragstart)="onDragStart($event, module)"
                    (dragend)="onDragEnd($event, module)"
                    (mouseenter)="previewModuleChange.emit(module)"
                    (mouseleave)="previewModuleChange.emit(null)">
                    <a class="nav-sidebar-link sidebarMenuItem" [attr.id]="'module' + module.ModuleID">
                        <div class="dropdownIcon"></div><span class="dropdownText">{{ module.LocalizedName }}</span>
                    </a>
                </li>
            </ul>
        </li>
    </ul>
</overlay-scrollbars>
